import React from 'react';
import { motion } from 'framer-motion';

const AboutESPOCH: React.FC = () => {
  return (
    <section className="bg-slate-50 py-24" id="about-espoch">
      <div className="mx-auto max-w-7xl px-6 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 55 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16 space-y-4"
        >
          <p className="text-xs font-bold uppercase tracking-[0.35em] text-slate-500">IEEE ESPOCH</p>
          <h2 className="text-4xl sm:text-5xl font-extrabold text-slate-900 leading-tight">
            La rama estudiantil que impulsa <span className="text-cyan-600">talento e innovación</span>
          </h2>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-slate-600 font-normal">
            IEEE ESPOCH es la comunidad que combina investigación, eventos y proyectos con un enfoque profesional y social, siendo referente en la Escuela Superior Politécnica de Chimborazo.
          </p>
        </motion.div>

        <div className="grid gap-12 lg:grid-cols-2">
          {/* Identidad Card */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="rounded-[2.5rem] border border-slate-100 bg-white p-10 shadow-premium"
          >
            <h3 className="text-3xl font-black text-slate-900">Nuestra identidad</h3>
            <p className="mt-6 text-slate-600 leading-relaxed font-normal">
              Somos el espacio donde los estudiantes de ingeniería construyen, investigan y aprenden juntos. 
              Organizamos hackathons, workshops y conferencias con visión global.
            </p>
            <div className="mt-10 space-y-4">
              {[
                'Innovación tecnológica como motor central.',
                'Enfoque en desarrollo humano y profesional.',
                'Compromiso con la comunidad local.',
              ].map((item, index) => (
                <div key={index} className="flex gap-4 rounded-2xl border border-slate-50 bg-slate-50/50 p-5 transition-colors hover:bg-cyan-50/50">
                  <span className="mt-1.5 h-2.5 w-2.5 rounded-full bg-cyan-600 flex-shrink-0 shadow-[0_0_8px_rgba(8,145,178,0.3)]" />
                  <span className="text-slate-700 font-medium">{item}</span>
                </div>
              ))}
            </div>
          </motion.div>

          {/* Misión y Visión Card */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="rounded-[2.5rem] border border-slate-100 bg-white p-10 shadow-premium"
          >
            <h3 className="text-3xl font-black text-slate-900">Misión y visión</h3>
            <div className="mt-10 space-y-10">
              <div className="group">
                <h4 className="text-xl font-bold text-cyan-700 uppercase tracking-widest flex items-center gap-3">
                  <div className="h-1 w-6 bg-cyan-600 rounded-full" />
                  Misión
                </h4>
                <p className="mt-4 text-slate-600 leading-relaxed font-normal">
                  Promover el crecimiento académico, tecnológico y profesional de los estudiantes de ESPOCH
                  mediante actividades y proyectos de alto nivel técnico y social.
                </p>
              </div>
              <div className="group">
                <h4 className="text-xl font-bold text-indigo-700 uppercase tracking-widest flex items-center gap-3">
                  <div className="h-1 w-6 bg-indigo-600 rounded-full" />
                  Visión
                </h4>
                <p className="mt-4 text-slate-600 leading-relaxed font-normal">
                  Ser una rama estudiantil líder en la región, reconocida por su innovación, excelencia académica y capacidad de liderazgo transformador.
                </p>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Valores */}
        <motion.div
          initial={{ opacity: 0, y: 55 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mt-24 text-center"
        >
          <h3 className="text-3xl font-black text-slate-900">Valores de IEEE ESPOCH</h3>
          <div className="mt-12 grid gap-8 md:grid-cols-3">
            {[
              { title: 'Innovación', text: 'Ideas que transforman industrias y resuelven problemas reales.', color: 'border-cyan-200' },
              { title: 'Colaboración', text: 'Conexiones entre estudiantes, profesores y redes globales.', color: 'border-indigo-200' },
              { title: 'Excelencia', text: 'Disciplina técnica y visión de calidad en cada iniciativa.', color: 'border-blue-200' },
            ].map((value, index) => (
              <div key={index} className={`rounded-3xl border border-slate-100 bg-white p-8 shadow-sm transition-all duration-300 hover:shadow-premium hover:-translate-y-2`}>
                <h4 className="text-xl font-black text-slate-900">{value.title}</h4>
                <div className="h-1 w-8 bg-slate-200 mx-auto my-4 rounded-full" />
                <p className="text-slate-500 leading-relaxed font-normal">{value.text}</p>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutESPOCH;
